import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useContext } from 'react';
export var initialState = {
  map: undefined,
  BMap: undefined,
  container: undefined
};
export var reducer = (state, action) => {
  return _extends({}, state, action);
};
export var Context = /*#__PURE__*/React.createContext({
  state: initialState,
  dispatch: () => null
});
export function useMapContext() {
  var {
    state,
    dispatch
  } = useContext(Context);
  return _extends({}, state, {
    state,
    dispatch
  });
}